// extracted by mini-css-extract-plugin
module.exports = {"container":"Pins_container__bibcX","cards":"Pins_cards__sVUIl","carousel":"Pins_carousel__KOWgm","spacer":"Pins_spacer__IDdDm"};